import React from 'react';

import { Helmet } from 'react-helmet-async';
import { defineMessages, useIntl } from 'react-intl';

const StoreLocatorMeta: React.FC = () => {
  const { formatMessage } = useIntl();

  return <Helmet title={formatMessage(messages.findARestaurant)} />;
};

export default StoreLocatorMeta;
const messages = defineMessages({
  findARestaurant: {
    id: 'findARestaurant',
    defaultMessage: 'Find a Restaurant',
    description: 'No description',
  },
});
